import { Action } from '@ngrx/store';

import { TaskActionType } from './task-action-type.enum';


export class SelectTask implements Action {
  public readonly type: TaskActionType = TaskActionType.SelectTask;

  constructor(public readonly payload: number) { }
}

export class SelectTaskCompleted implements Action {
  public readonly type: TaskActionType = TaskActionType.SelectTaskCompleted;

  constructor(public readonly payload: number) { }
}

export class SelectTaskFailed implements Action {
  public readonly type: TaskActionType = TaskActionType.SelectTaskFailed;

  constructor(public readonly payload: string) { }
}
